// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ContentSection from "common/src/ContentSection.bs.js";

function SupSection(Props) {
  var children = Props.children;
  var id = Props.id;
  var title = Props.title;
  var text = Props.text;
  return React.createElement("div", {
              className: "self-stretch mt-12 p-4 py-6 border-2 border-solid rounded bg-primary-2a border-primary-11 flex flex-col items-center",
              id: id
            }, React.createElement(ContentSection.make, {
                  className: "flex items-center justify-center mb-8 gap-8 border-secondary-11 border-b-2 border-b-2 min-w-[350px] max-w-[600px] leading-tight ",
                  children: null
                }, React.createElement("h2", {
                      className: "text-xl font-montserrat font-medium flex-shrink-0"
                    }, title), text !== undefined ? text : null), children);
}

var make = SupSection;

export {
  make ,
  
}
/* react Not a pure module */
